import styled from "styled-components";
import { Mail, MapPin, Clock } from "lucide-react";

const items = [
  { icon: Mail, label: "Email", value: "support@dealbeez.com" },
  { icon: MapPin, label: "Location", value: "San Francisco, CA" },
  { icon: Clock, label: "Response Time", value: "Within 24 hours" },
];

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Card = styled.div`
  background: hsl(${({ theme }) => theme.colors.card});
  border-radius: ${({ theme }) => theme.radius.xl};
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  padding: 1.25rem;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
`;

const IconBox = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: ${({ theme }) => theme.radius.lg};
  background: hsl(${({ theme }) => theme.colors.primary} / 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: hsl(${({ theme }) => theme.colors.primary});
`;

const Label = styled.p`
  margin: 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: hsl(${({ theme }) => theme.colors.foreground});
`;

const Value = styled.p`
  margin: 0.125rem 0 0;
  font-size: 0.875rem;
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
`;

export default function ContactInfoCards() {
  return (
    <Stack>
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <Card key={item.label}>
            <IconBox>
              <Icon size={20} strokeWidth={2} />
            </IconBox>
            <div>
              <Label>{item.label}</Label>
              <Value>{item.value}</Value>
            </div>
          </Card>
        );
      })}
    </Stack>
  );
}
